var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height}),attrs:{"id":"app"}},[(_vm.name)?_c('Image360',{attrs:{"texturePath":_vm.getTexturePath(_vm.name),"quality":_vm.quality}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }